var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34148 6.78377L0.0914762 0.533768C0.0624418 0.504733 0.0394107 0.470265 0.0236974 0.432329C0.00798405 0.394394 -0.000103951 0.353735 -0.000103951 0.312674C-0.000103951 0.271613 0.00798405 0.230954 0.0236974 0.193019C0.0394107 0.155084 0.0624418 0.120615 0.0914762 0.0915802C0.120511 0.0625457 0.15498 0.0395147 0.192915 0.0238013C0.23085 0.008088 0.271509 0 0.31257 0C0.353631 0 0.39429 0.008088 0.432225 0.0238013C0.470161 0.0395147 0.50463 0.0625457 0.533664 0.0915802L6.56257 6.12049L12.5915 0.0915802C12.6501 0.0329424 12.7296 0 12.8126 0C12.8955 0 12.975 0.0329424 13.0337 0.0915802C13.0923 0.150218 13.1252 0.229748 13.1252 0.312674C13.1252 0.3956 13.0923 0.47513 13.0337 0.533768L6.78366 6.78377C6.75464 6.81282 6.72018 6.83587 6.68224 6.8516C6.6443 6.86733 6.60364 6.87542 6.56257 6.87542C6.5215 6.87542 6.48084 6.86733 6.4429 6.8516C6.40496 6.83587 6.3705 6.81282 6.34148 6.78377Z",
    fill: "#4D5F6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downArrow.93a3eaa1421e8c08d2bb01e5118c015b.svg";